export default class Endereco {
	constructor() {
		this.rua = '',
        this.numero =  '',
        this.complemento =  '',
        this.tipoLocal = '',
        this.cep = '',
        this.bairro = '',
        this.cidade = {
            id: null,
            nome: ''
        }
	}    
}